import type { VideoContentObject } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Icon, type MenuProps } from 'ui';
import { useDeleteVideo } from './useDeleteVideo';

export const useActions = ({
  onRequestEdit,
  onVideoDeleted,
  videoContentObject,
}: {
  onRequestEdit: (opened: true) => void;
  onVideoDeleted: () => Promise<void>;
  videoContentObject: VideoContentObject;
}) => {
  const { t } = useTranslation();
  const { confirm: deleteVideo, contextHolder } = useDeleteVideo({ onVideoDeleted, videoContentObject });
  const { canDeleteVideo, canEditVideo } = usePermissions();

  return useMemo(() => {
    const actions: MenuProps['items'] = [];

    if (canEditVideo({ video: videoContentObject })) {
      actions.push({
        icon: <Icon icon="pencil-line" />,
        key: 'edit',
        label: t('Edit'),
        onClick() {
          onRequestEdit(true);
        },
      });
    }

    if (canDeleteVideo({ video: videoContentObject })) {
      actions.push({
        danger: true,
        icon: <Icon icon="delete-2-line" />,
        key: 'delete',
        label: t('Delete draft'),
        onClick() {
          deleteVideo();
        },
      });
    }

    return {
      actions,
      contextHolder,
    };
  }, [canEditVideo, videoContentObject, canDeleteVideo, contextHolder, t, onRequestEdit, deleteVideo]);
};
